<template>
  <div>
    <b-notification :has-icon="true" icon="database" :closable="false">
      <span v-html="$t('compCarbonFormsCommutesHelpData.text')" />
    </b-notification>
  </div>
</template>

<script>
export default {
  name: 'HelpData'
}
</script>
